import FormattedMessage from 'I18n/components/FormattedMessage';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { DialogHeaderImage } from 'foundations-components/transitional/components/DialogHeaderImage';
import { H2 } from 'UIComponents/elements/headings';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const FeatureSurveyModalHeader = () => {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(DialogHeaderImage, {
      offsetBottom: -30,
      offsetTop: 40,
      children: /*#__PURE__*/_jsx(Illustration, {
        name: "success",
        width: 118
      })
    }), /*#__PURE__*/_jsx(DialogHeader, {
      children: /*#__PURE__*/_jsx(Flex, {
        flexDirection: "column",
        children: /*#__PURE__*/_jsx(H2, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "upgrades.trialFeatureSurvey.common.trialTitle"
          })
        })
      })
    })]
  });
};